import { createReducer, on } from "@ngrx/store";
import { Form } from "../../../domain/form.interface";
import { Pagination } from "../../../domain/pagination.interface";
import { TemplateState } from "../states/template.state";

import {
  loadTemplatesList,
  loadTemplatesListSuccess,
  loadTemplatesListFailure,
  getSelectedTemplate,
  getSelectedTemplateSuccess,
  getSelectedTemplateFailure,
  deleteTemplate,
  deleteTemplateSuccess,
  deleteTemplateFailure,
  addTemplate,
  addTemplateSuccess,
  addTemplateFailure,
  editTemplate,
  editTemplateFailure,
  editTemplateSuccess
} from "../actions/template.actions";

export const initialPagination: Pagination = {
  total: 0,
  pages: 1,
  next: null,
  previous: null,
  current: 1,
  entries: 50,
};

export const initialState: TemplateState = {
  templates: null,
  selectedTemplate: null,
  error: null,
  listStatus: "pending",
  getStatus: "pending",
  createStatus: "pending",
  updateStatus: "pending",
  deleteStatus: "pending",
  pagination: initialPagination
};

export const templateReducer = createReducer(
  // Supply the initial state
  initialState, 
  // Handle list
  on(loadTemplatesList, (state) => ({
    ...state,
    listStatus: "loading" as TemplateState["listStatus"],
  })),
  // Handle successfully list
  on(loadTemplatesListSuccess, (state, { data }) => {
    console.log('DATA TEMPLATE LIST->', data)
    
    return {
      ...state,
      templates: data.results,
      error: null,     
      pagination: data.pagination,
      listStatus: "success" as TemplateState["listStatus"]
    }
  }),
  // Handle failure list
  on(
    loadTemplatesListFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    listStatus: "error" as TemplateState["listStatus"],
  })),
  // Handle get selected
  on(getSelectedTemplate, (state) => ({
    ...state,
    getStatus: "loading" as TemplateState["getStatus"],
  })),
  // Handle successfully get selected
  on(getSelectedTemplateSuccess, (state, { template }) => {    
    return {
      ...state,
      selectedTemplate: template,
      error: null,
      getStatus: "success" as TemplateState["getStatus"]
    }
  }),
  // Handle failure get
  on(
    getSelectedTemplateFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    getStatus: "error" as TemplateState["getStatus"],
  })),
   // Handle delete
   on(deleteTemplate, (state) => ({
    ...state,
    deleteStatus: "loading" as TemplateState["deleteStatus"]
  })),
  // Handle successfully delete
  on(deleteTemplateSuccess, (state, { pk, sk }) => ({
    ...state,
    deleteStatus: "success" as TemplateState["deleteStatus"],
    selectedTemplate: state.selectedTemplate.sk == sk ? null : state.selectedTemplate,
    pagination : {
      ...state.pagination,
      total: state.pagination.total - 1
    },
    templates: [...state.templates.filter((template) => template.sk !== sk)],
  })),
  // Handle failure delete
  on(
    deleteTemplateFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    deleteStatus: "error" as TemplateState["deleteStatus"],
  })),
  // Handle add
  on(addTemplate, (state) => ({
    ...state,
    createStatus: "loading" as TemplateState["createStatus"]
  })),
  // Handle successfully add
  on(addTemplateSuccess, (state, { template }) => {    
    return {
      ...state,
      templates: [template, ...state.templates],
      selectedTemplate: template,
      pagination : {
        ...state.pagination,
        total: state.pagination.total + 1
      },
      createStatus: "success" as TemplateState["createStatus"]
    }
  }),
  // Handle failure add
  on(
    addTemplateFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    createStatus: "error" as TemplateState["createStatus"],
  })),
  // Handle edit
  on(editTemplate, (state) => ({
    ...state,
    updateStatus: "loading" as TemplateState["updateStatus"]
  })),
  // Handle successfully edit
  on(editTemplateSuccess, (state, { template }) => ({
    ...state,
    templates: state.templates.map((templateItem) =>
      templateItem.sk === template.sk && templateItem.pk === template.pk ? template : templateItem
    ),
    selectedTemplate: template,
    updateStatus: "success" as TemplateState["updateStatus"]
  })),
  // Handle failure edit
  on(
    editTemplateFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    updateStatus: "error" as TemplateState["updateStatus"],
  })),
);

